import type { Expression } from '~/prix/types/expression'

export const AGENT_POLYGON_CPF_PROPERTY = 'agentPolygonCpf'

export const extractStringEqualityValue = (
  expression: Expression | null | undefined,
  property: string,
): string | null => {
  if (!expression) {
    return null
  }

  if (
    expression.kind === 'binary' &&
    expression.operator === '=' &&
    expression.left.kind === 'property' &&
    expression.left.property === property &&
    expression.right.kind === 'literal' &&
    typeof expression.right.value === 'string'
  ) {
    return expression.right.value
  }

  switch (expression.kind) {
    case 'binary':
      return (
        extractStringEqualityValue(expression.left, property) ??
        extractStringEqualityValue(expression.right, property)
      )
    case 'ternary':
      return (
        extractStringEqualityValue(expression.condition, property) ??
        extractStringEqualityValue(expression.whenTrue, property) ??
        extractStringEqualityValue(expression.whenFalse, property)
      )
    case 'unary':
      return extractStringEqualityValue(expression.operand, property)
    case 'summation':
    case 'function':
      for (const argument of expression.arguments) {
        const value = extractStringEqualityValue(argument, property)

        if (value) {
          return value
        }
      }

      return null
    case 'list':
      for (const item of expression.items) {
        const value = extractStringEqualityValue(item, property)

        if (value) {
          return value
        }
      }

      return null
    default:
      return null
  }
}
